var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 5.49998V7.71831C20.1665 9.16664 19.2498 10.0833 17.8015 10.0833H14.6665V3.67581C14.6665 2.65831 15.5007 1.83331 16.5182 1.83331C17.5173 1.84248 18.434 2.24581 19.094 2.90581C19.754 3.57498 20.1665 4.49165 20.1665 5.49998Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8335 6.41665V19.25C1.8335 20.0108 2.69516 20.4416 3.30016 19.9833L4.86766 18.81C5.23433 18.535 5.74766 18.5716 6.07766 18.9016L7.59933 20.4325C7.95683 20.79 8.5435 20.79 8.901 20.4325L10.441 18.8925C10.7618 18.5716 11.2752 18.535 11.6327 18.81L13.2002 19.9833C13.8052 20.4325 14.6668 20.0016 14.6668 19.25V3.66665C14.6668 2.65831 15.4918 1.83331 16.5002 1.83331H6.41683H5.50016C2.75016 1.83331 1.8335 3.47415 1.8335 5.49998V6.41665Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 11.9258H11",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.25916H11",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49609 11.9167H5.50433",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49609 8.25H5.50433",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDetails);
export default __webpack_public_path__ + "static/media/payment-details.0f0ff15c537d930f0495e3bfa597c902.svg";
export { ForwardRef as ReactComponent };